import { Pipe, PipeTransform } from '@angular/core';
import SOUND_TYPES_LIST from '../../../assets/data/sound-uploading.json';
@Pipe({
  name: 'elementKeyName'
})
export class ElementKeyNamePipe implements PipeTransform {
  soundData: any = SOUND_TYPES_LIST;
  transform(value: any, selectedPakType: string, type: any = ""): any {
    let finalString: string = "";
    if (this.soundData) {
      if (type) {
        let currentPackType: any = this.getValueFromDropDown('keys', value);
        finalString = currentPackType?.value;
      } else {
        let keyValue: any = Object.keys(value);
        delete keyValue['elementName'];
        delete keyValue['count'];
        let currentPackType: any = this.getValueFromDropDown('packType',selectedPakType);
        if (currentPackType) {
          let elementList: any =  currentPackType.elementList;
          if (elementList) {
            let foundElement: any =  elementList.find((item: any) => item.key === value.elementName);
            const div = document.createElement('span');
            if (foundElement) {
                if (foundElement?.referList.length > 0) {
                  let referList = foundElement?.referList;
                  //   keyValue.filter
                  // // let referElementData  = this.getValueFromDropDown('elementForLoopType', value);
                } else {
                  finalString =  foundElement?.value;
                }
            }
          }
        }
      }
    }
    return finalString;
  }

  getValueFromDropDown(keyname: any, subKey: any) {
    let selectedData: any = "";
    let arrayListParent: any = this.soundData[keyname];
    if (arrayListParent) {
      selectedData = arrayListParent.find((item: any) => item.key === subKey)
    }
    return selectedData ?  selectedData : null;
  }

}
